import ChildcareVoucherOrderPage from '@/common/pages/(private)/(dashboard)/benefits/childcare-voucher/[voucherId]';

export default function Page() {
  return <ChildcareVoucherOrderPage />;
}
